import React from 'react'
import { useTranslation } from 'react-i18next';

function About() {
    const { t } = useTranslation();

    return (
        <section className="about-section py-5" >
            <div className="container" >
                {/* Title */}
                <div className="text-center mb-5">
                    <h2 className="fw-bold">{t('aboutTitle')}</h2>
                    <p className="text-muted mt-2">
                        {t('aboutSubtitle')}
                    </p>
                </div>

                <div className="row align-items-center g-5">
                    {/* LEFT CONTENT */}
                    <div className="col-md-6" data-aos="fade-right">
                        <h4 className="fw-semibold mb-3">
                            {t('aboutSectionTitle')}
                        </h4>
                        <p className="text-muted">
                            {t('aboutPara1')}
                        </p>
                        <p className="text-muted">
                            {t('aboutPara2')}
                        </p>

                        {/* FEATURES */}
                        <div className="row mt-4" data-aos="zoom-in" data-aos-delay="90000" >
                            {[
                                t('feature1'),
                                t('feature2'),
                                t('feature3'),
                                t('feature4'),
                            ].map((item, idx) => (
                                <div key={idx} className="col-6 mb-3">
                                    <div className="about-feature1">
                                        <span>✔</span> {item}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* RIGHT CARDS */}
                    <div className="col-md-6" data-aos="fade-left" data-aos-delay="200">
                        <div className="row g-4">
                            <div className="col-6">
                                <div className="about-card shadow-sm">
                                    <h3>50+</h3>
                                    <p>{t('warehouses')}</p>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="about-card shadow-sm">
                                    <h3>10L+</h3>
                                    <p>{t('storageCapacity')}</p>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="about-card shadow-sm">
                                    <h3>24/7</h3>
                                    <p>{t('securityMonitoring')}</p>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="about-card shadow-sm">
                                    <h3>100%</h3>
                                    <p>{t('qualityAssurance')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About